export const ResponseColumnsPackage = [
  'ASI',
  'Brand',
  'Currency',
  'Description',
  'EffectiveDate',
  'HwType',
  'IsRenewable',
  'FnaProductCode',
  'MarketingDescription',
  'NetPrice',
  'Region',
  'Status',
  'TMNAPackageId',
  'Term',
  'TotalDiscount',
  'TotalListPrice',
  'Type',
  'errorDescription'
];
